import { render } from "./Ignorations.vue?vue&type=template&id=2bfb1cfe"
import script from "./Ignorations.vue?vue&type=script&lang=js"
export * from "./Ignorations.vue?vue&type=script&lang=js"
script.render = render

export default script